// (c) chaehongee. Confidential and proprietary.

import type { RootState } from '../store'
import type { SessionInfoResponse as SessionInfo } from 'models-ts/session'

export function selectActiveSessionId(state: RootState): string | null {
    return state.sessionTabs.activeSessionId
}

export function selectSessionById(state: RootState, sessionId: string): SessionInfo | null {
    return state.session.sessionsById[sessionId] ?? null
}

export function selectActiveSession(state: RootState): SessionInfo | null {
    const id = selectActiveSessionId(state)
    return id ? selectSessionById(state, id) : null
}

export function selectIsSessionLoading(state: RootState, sessionId: string): boolean {
    return Boolean(state.session.isLoadingBySessionId[sessionId])
}

export function selectIsActiveSessionLoading(state: RootState): boolean {
    const id = selectActiveSessionId(state)
    return id ? selectIsSessionLoading(state, id) : false
}

export function selectActiveSessionLoadingMessage(state: RootState): string | null {
    const id = selectActiveSessionId(state)
    return id ? (state.session.loadingMessageBySessionId[id] ?? null) : null
}

export function selectSessionError(state: RootState, sessionId: string): string | null {
    return state.session.errorBySessionId[sessionId] ?? null
}

export function selectActiveSessionError(state: RootState): string | null {
    const id = selectActiveSessionId(state)
    return id ? selectSessionError(state, id) : null
}

